import type { IconData } from '@stacksjs/iconify-core'

export const otherArrowsMove: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m0 7l2-2l3 3l-3 3l-2-2v7h7l-2-2l3-3l3 3l-2 2h7V9l-2 2l-3-3l3-3l2 2V0H9l2 2l-3 3l-3-3l2-2H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherArrowsMove
